import { useMemo } from 'react';
import { Card, Body1, SectionHeader } from '../../blocks';
import { genDestinationAttributes } from '@onward-delivery/core';
import { toNational } from '@/utilities/formatPhoneNumber';
import { toFullState } from '@/utilities/address';
import { startCase } from 'lodash';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';

const OrderDestinationCard = ({ claim, order }) => {
    const isReturn = useMemo(() => {
        return ['return', 'wh_return'].includes(order?.order_type);
    }, [order]);

    const { name, phone, email, location_type, address } = useMemo(() => {
        const { street, unit, city, state, zip, location, location_info, location_type } = genDestinationAttributes(
            order,
            !!claim.middle_mile_carrier_id
        );
        return {
            ...(!!claim.middle_mile_carrier_id
                ? {
                      name: isReturn ? order.middle_mile_origin_name : order.pickup_name,
                      phone: isReturn ? order.middle_mile_origin_phone : order.pickup_phone,
                      email: isReturn ? order.middle_mile_origin_email : order.pickup_email,
                  }
                : {
                      name: isReturn ? order.pickup_name : order.dropoff_name,
                      phone: isReturn ? order.pickup_phone : order.dropoff_phone,
                      email: isReturn ? order.pickup_email : order.dropoff_email,
                  }),
            location_type: [location, location_info, location_type]
                .map((attr) => (attr ? order[attr] : null))
                .filter((x) => !!x)
                .map((val) => startCase(val))
                .join(', '),
            address: `${order[street]}${order[unit] ? ` ${order[unit]}` : ''} ${order[city]}, ${toFullState(
                order[state]
            )} ${order[zip]}`,
        };
    }, [order, isReturn]);

    const comments = useMemo(() => {
        return (order?.notes || [])
            .filter((note) => note.type === 'Delivery' && !note.private_to)
            .map((note) => note.note)
            .filter((x) => !!x)
            .join('\n');
    }, [order]);

    return (
        <Card>
            <Grid
                item
                css={css`
                    margin-bottom: 1rem;
                `}
            >
                <SectionHeader>{isReturn ? 'Return Dropoff' : 'Dropoff'}</SectionHeader>
            </Grid>
            <Grid item>
                <Body1>{name}</Body1>
            </Grid>
            <Grid item>
                <Body1>{toNational(phone)}</Body1>
            </Grid>
            <Grid item>
                <Body1>{email}</Body1>
            </Grid>
            <Grid item>
                <Body1>{address}</Body1>
            </Grid>
            <Grid item>
                <Body1>{location_type}</Body1>
            </Grid>
            <Grid item>
                <Body1>Comments: {comments || '--'}</Body1>
            </Grid>
        </Card>
    );
};

export default OrderDestinationCard;
